export const SAVE_USER_NAME = "save_user_name";
export const SAVE_LOAN_ID = "save_loan_id";
export const ACTION_TYPE_FOR_ADMIN_AUDIT = [
  {
    value: "",
    name: "selectUserAction",
  },
  {
    value: "ADD_NEW_USER",
    name: "ADD_NEW_USER",
  },
  {
    value: "DATA_MODIFIED",
    name: "DATA_MODIFIED",
  },
  {
    value: "ACCESS_MODIFIED",
    name: "ACCESS_MODIFIED",
  },
];

export const ACTION_TYPE_FOR_LOAN_AUDIT_AUDIT = [
  {
    value: "",
    name: "selectUserAction",
  },
  {
    value: "STATUS_CHANGED",
    name: "STATUS_CHANGED",
  },
  {
    value: "PAYMENT_RECEIVED",
    name: "PAYMENT_RECEIVED",
  },
  {
    value: "LATE_FEES_ADDED",
    name: "LATE_FEES_ADDED",
  },
  {
    value: "LATE_FEES_REMOVED",
    name: "LATE_FEES_REMOVED",
  },
];

export const PERFOMER_ROLE = [
  {
    value: "",
    name: "selectPerformerRole",
  },
  {
    value: "ADMIN",
    name: "ADMIN",
  },
  {
    value: "CASHIER",
    name: "CASHIER",
  },
  {
    value: "ANALYST",
    name: "ANALYST",
  },
  {
    value: "CONFIGURATOR",
    name: "CONFIGURATOR",
  },
  {
    value: "GENERAL_MANAGER",
    name: "GENERAL_MANAGER",
  },
  {
    value: "CASHIER_MODERATOR",
    name: "CASHIER_MODERATOR",
  },
  {
    value: "CUSTOMER_CARE",
    name: "CUSTOMER_CARE",
  },
  {
    value: "ANALYST_MODERATOR",
    name: "ANALYST_MODERATOR",
  },
  {
    value: "CLIENT",
    name: "CLIENT",
  },
  {
    value: "OPERATIONS_OFFICER",
    name: "OPERATIONS_OFFICER",
  },
  {
    value: "LOAN_PORTFOLIO_MANAGER",
    name: "LOAN_PORTFOLIO_MANAGER",
  },
  {
    value: "COLLECTIONS_OFFICER",
    name: "COLLECTIONS_OFFICER",
  },
  {
    value: "COLLECTIONS_MODERATOR",
    name: "COLLECTIONS_MODERATOR",
  },
];

export const AUDIT_TYPE = {
  ADMIN_AUDIT: "SANERRET_ADMIN_AUDIT",
  CONFIGURATOR_AUDIT: "CONFIGURATOR_AUDIT",
  LOAN_AUDIT: "LOAN_AUDIT",
  USER_AUDIT: "USER_AUDIT",
};

export const PERFOMER_TYPE = [
  {
    value: "",
    name: "selectPerformerType",
  },
  {
    value: "USER",
    name: "USER",
  },
  {
    value: "SYSTEM",
    name: "SYSTEM",
  },
];
